/*
 * ---------------------------------------------------------------------
 * import modules
 * ---------------------------------------------------------------------
 */

import React, {forwardRef} from 'react';

import {
    MenuItem,
} from "@material-ui/core";

/*
 * ---------------------------------------------------------------------
 * Component AppFooter
 * ---------------------------------------------------------------------
 */
function LanguageSwitchItem(props, ref) {
    let label = props.langItem.code2.toUpperCase() + " - " + props.langItem.native;

    return (<MenuItem ref={ref} key={props.langItem.locale}
                    style={props.themedStyle}
                    selected={props.isSelected}
                    onClick={props.onClick}>
            {label}
        </MenuItem>);

}

export default forwardRef(LanguageSwitchItem);
